// PURPOSE: Report a manually sent outreach email using the shared action dialog.
// CONTRACT: Spec 068; the caller offers this only from server allowed_actions.
// DEPENDS: Catalog action dialog and native client version/idempotency envelope.
// CEILING: No Gmail access or sends; server validates dates and rung.
import { ActionDialog } from './forms';
import type { NativeRecord } from './types';

export function MarkSentDialog({ record, onClose, onSaved }: { record: NativeRecord; onClose(): void; onSaved(): void }) {
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  return <ActionDialog record={record} action={{ name: 'mark_sent', label: 'Mark sent', fields: [
    { name: 'rung', label: 'Email rung', type: 'select', required: true, default: String(record.data.last_drafted_rung || ''), options: [{ value: 'first_touch', label: 'Email 1' }, { value: 'mark1', label: 'Email 2' }, { value: 'mark2', label: 'Email 3' }] },
    { name: 'sent_on', label: 'Sent on', type: 'date', default: today },
    { name: 'gmail_message_id', label: 'Gmail message ID', type: 'string' },
    { name: 'gmail_thread_id', label: 'Gmail thread ID', type: 'string' },
  ] }} onClose={onClose} onSaved={onSaved} />;
}
